export function TxSendIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.998047 0C0.445762 0 -0.00195312 0.447715 -0.00195312 1C-0.00195312 1.55228 0.445762 2 0.998047 2H8.61174L0.292089 10.2927C-0.0990687 10.6826 -0.100097 11.3157 0.289793 11.7069C0.679683 12.0981 1.31285 12.0991 1.704 11.7092L9.99805 3.44204V11C9.99805 11.5523 10.4458 12 10.998 12C11.5503 12 11.998 11.5523 11.998 11V1C11.998 0.447715 11.5503 0 10.998 0H0.998047Z"
                fill="currentColor"
            />
        </svg>
    );
}
